import React, { Component } from 'react'
import { IMedia } from '@shared/Types'
import { Typography } from '@mui/material'
import { CreateSelectSimple } from '@lib/Forms/Inputs'
import { getMediaTypes, getMediaStatuses } from '@shared/Services'
import { FormValidator, SingleRuleValidate, FormModalWrapper, CreateFormGridLayout, CreateFormComfirm, DinoForm } from '@lib/Forms'
import { CategorySelectMultipleMapRedux } from '../CategoryDetail'

const SelectSimpleInstance = CreateSelectSimple<IMedia>()

const FormGridLayoutInstance = CreateFormGridLayout<IMedia>({
  configs: [
    { key: 'Name', label: 'Name hello' },
    {
      key: 'CategoryNames',
      inputElement: (p) => {
        if (!p.data?.Id) return <></>
        return <CategorySelectMultipleMapRedux param={{ mediaId: p.data.Id }} />
      },
      alwaysDisplayed: (value) => !!value?.Id
    },
    { key: 'ResourceId', label: 'ResourceId', reponsives: { md: 6 }, disabled: true },
    {
      key: 'Type',
      label: 'Type',
      reponsives: { md: 6 },
      disabled: true,
      inputElement: (p) => <SelectSimpleInstance {...p} options={getMediaTypes()} />
    },
    { key: 'Extension', label: 'Extension', reponsives: { md: 6 }, disabled: true },
    { key: 'Duration', label: 'Duration', reponsives: { md: 6 }, disabled: true },
    { key: 'Size', label: 'Size', reponsives: { md: 6 }, disabled: true },
    {
      key: 'Status',
      label: 'Status',
      reponsives: { md: 6 },
      alwaysDisplayed: (value) => !!value,
      inputElement: (p) => <SelectSimpleInstance {...p} options={getMediaStatuses()} />
    },
    { key: 'Reason', label: 'Reason' },
    {
      key: 'Description',
      label: 'Description',
      inputElement: DinoForm.createTextEditor({ id: 'form_media_text_editor_010425', title: 'Media description' })
    }
  ],
  validate: new FormValidator({
    Name: { Rules: [{ rule: SingleRuleValidate.Required }] },
    Type: { Rules: [{ rule: SingleRuleValidate.Required }] },
    Status: { Rules: [{ rule: SingleRuleValidate.Required }] },
    Duration: { Rules: [{ rule: SingleRuleValidate.Required }] },
    Size: { Rules: [{ rule: SingleRuleValidate.Required }] },
    Extension: { Rules: [{ rule: SingleRuleValidate.Required }] },
    ResourceId: { Rules: [{ rule: SingleRuleValidate.Required }] }
  })
})

// ========= ========= ========= Form Create ========= ========= =========
interface IFormCreateProps {
  onSubmit: (value: Partial<IMedia>) => Promise<void>
}
export class FormCreate extends Component<IFormCreateProps> {
  render() {
    return (
      <FormModalWrapper title='Create' size='md'>
        <FormGridLayoutInstance onSubmit={this.props.onSubmit} />
      </FormModalWrapper>
    )
  }
}

// ========= ========= ========= Form Edit ========= ========= =========
interface IFormEditProps {
  data: IMedia
  onSubmit: (value: Partial<IMedia>) => Promise<void>
}
export class FormEdit extends Component<IFormEditProps> {
  render() {
    return (
      <FormModalWrapper title='Edit' size='md'>
        <FormGridLayoutInstance data={this.props.data} onSubmit={this.props.onSubmit} />
      </FormModalWrapper>
    )
  }
}

// ========= ========= ========= Form Delete ========= ========= =========
export const FormDelete = CreateFormComfirm<IMedia>({
  title: 'Are yout sure delete?',
  content: (x) => <Typography variant='subtitle2'>{x?.Name}</Typography>
})
